import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import {
  Paper,
  Typography,
  makeStyles,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'

import helpers from 'helpers'
import styles from './styles'

const useStyles = makeStyles(styles)

const CardPlan = ({
  plan,
  expandOnMouseOver = false,
  onClickSubscribe = () => {},
  onClickAddToCart = () => {},
  hideInfoMobile = false,
  children,
  ...rest
}) => {
  const classes = useStyles()
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('sm'))

  const price = React.useMemo(
    () => helpers.currency(plan.price, { hideSymbol: true }),
    [plan],
  )

  return (
    <Paper
      variant="outlined"
      className={clsx(classes.root, rest.className, {
        [classes.rootSuggested]: plan.suggested,
        [classes.rootExpandHover]: expandOnMouseOver,
      })}
    >
      {plan.suggested && (
        <div className={classes.suggestedBox}>
          <Typography className={classes.suggested}>Recomendado</Typography>
        </div>
      )}

      <Typography variant="h3" className={classes.name}>
        {plan.name}
      </Typography>

      <div className={classes.priceBox}>
        <Typography className={classes.price}>
          <Typography component="span" className={classes.pricePrefix}>
            R$
          </Typography>
          {price}
        </Typography>

        <Typography variant="body2" className={classes.periodicity}>
          {helpers.plans.formatPeriodicityCheckout(plan.periodicity)}
        </Typography>
      </div>

      {hideInfoMobile && !matches ? (
        <></>
      ) : (
        <Typography variant="body2" className={classes.description}>
          {plan.description}
        </Typography>
      )}

      {children}
    </Paper>
  )
}

CardPlan.propTypes = {
  plan: PropTypes.object.isRequired,
  expandOnMouseOver: PropTypes.bool,
  onClickSubscribe: PropTypes.func,
  onClickAddToCart: PropTypes.func,
}

export default CardPlan
